import "../../../../css/modal/UserDetailsModal.css"
import UserListInfo from "../../../../utils/UserListInfo";
import LocationCode from "../../../../utils/constants/LocationCode";
import FunnelCode from "../../../../utils/constants/FunnelCode";
import Gender from "../../../../utils/constants/Gender";
import UserPasswordResetModal from "./UserPasswordResetModal";
import EditRegisterDueModal from "./EditRegisterDueModal";
import {getDateString, moveModal, phoneNumberWithHyphen} from "../../../../utils/Utils";
import {useEffect, useRef, useState} from "react";
import proxy from "../../../../utils/Proxy";

let UserDetailsModal = (props) => {
    let ref = useRef(null)
    let [resetPasswordIsOpen, setResetPasswordIsOpen] = useState(false)
    let [editRegisterDueIsOpen, setEditRegisterDueIsOpen] = useState(false)
    let data = {}
    for (let name of UserListInfo.detailDataName)
        data[name] = props.data[name]

    data["location"] = LocationCode.text[data["location"]]
    data["birth"] = getDateString(new Date(data["birth"]))
    data["contact"] = phoneNumberWithHyphen(data["contact"])
    data["howto"] = FunnelCode.text[data["howto"]]
    data["registration"] = getDateString(new Date(data["registration"]))
    data["register_start_date"] = getDateString(new Date(data["register_start_date"]))
    data["register_end_date"] = getDateString(new Date(data["register_end_date"]))

    let onSubmitRegisterDue = () => {
        proxy.get("/adminapi/payments/users/" + props.data.userid + "/now").then(response => {
            let paymentRes = response.data
            props.setDetailData(prevState => {
                return {
                    ...prevState,
                    isRegister: paymentRes.isRegister,
                    register_message: paymentRes.message,
                    paymentid: paymentRes.data.paymentid,
                    register_start_date: paymentRes.data.start,
                    register_end_date: paymentRes.data.end,
                    startdate_non_set: paymentRes.data.startdate_non_set
                }
            })
            setEditRegisterDueIsOpen(false)
        })
    }

    let onClickDeleteUserAccount = () => {
        let dialogResult = window.confirm("수강생 정보를 삭제하겠습니까?")

        if (dialogResult) {
            let userid = props.data.userid
            proxy.delete("/adminapi/users/" + userid).then(() => {
                window.alert("탈퇴 처리되었습니다.")
                props.onCloseClick()
            }).catch(res => window.alert(res.response.data.message));
        }
    }

    const handleClickOutSide = (e) => {
        if (!ref.current.contains(e.target)) {
            props.onCloseClick()
        }
    }
    useEffect(() => {
        document.addEventListener('mouseup', handleClickOutSide)
        return () => {
            document.removeEventListener('mouseup', handleClickOutSide)
        }
    })
    return (
        <div className="modal-container">
            <div className="modal" id="user-details-modal" ref={ref}>
                <div className="modal-content-container">
                    <div className="modal-header" onMouseDown={(e) => moveModal(e, "user-details-modal")}>
                        <p className="modal-title">
                            수강생 정보
                        </p>
                        <div className="modal-close-button" onClick={props.onCloseClick}></div>
                    </div>
                    <div className="modal-content">
                        <div className="modal-content-items-container">
                            {UserListInfo.detailLabel.map((label, index) => {
                                if (label === "등록기간") {
                                    if (props.data.isRegister) {
                                        if (props.data.startdate_non_set) {
                                            return (
                                                <div className="modal-content-item modal-content-align-start"
                                                     key={"detail-modal-" + index}>
                                                    <div className="modal-content-divider-2">
                                                        <p className="modal-content-text">{label}</p>
                                                    </div>
                                                    <div className="modal-content-divider-2"
                                                         id="user-detail-inline-button-container">
                                                        <p className="modal-content-text">시작일 미정</p>
                                                        <div className="modal-content-inline-button "
                                                             onClick={() => setEditRegisterDueIsOpen(true)}>
                                                            <p>설정</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        } else {
                                            return (
                                                <div className="modal-content-item modal-content-align-start"
                                                     key={"detail-modal-" + index}>
                                                    <div className="modal-content-divider-2">
                                                        <p className="modal-content-text">{label}</p>
                                                    </div>
                                                    <div className="modal-content-divider-2">
                                                        <p className="modal-content-text">{data["register_start_date"]} ~ {data["register_end_date"]}</p>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    } else {
                                        return (
                                            <div className="modal-content-item modal-content-align-start"
                                                 key={"detail-modal-" + index}>
                                                <div className="modal-content-divider-2">
                                                    <p className="modal-content-text">{label}</p>
                                                </div>
                                                <div className="modal-content-divider-2">
                                                    <p className="modal-content-text">미등록</p>

                                                </div>
                                            </div>
                                        )
                                    }
                                } else if (label === "" || label === "성별") return null
                                if (label === "문자수신 여부") {
                                    let subscribedString = data["subscribed"] ? "수신 허용됨" : "수신 거부됨";
                                    return (<div className="modal-content-item modal-content-align-start"
                                                 key={"detail-modal-" + index}>
                                        <div className="modal-content-divider-2">
                                            <p className="modal-content-text">{label}</p>
                                        </div>
                                        <div className="modal-content-divider-2">
                                            <p className="modal-content-text">{subscribedString}</p>
                                        </div>
                                    </div>)
                                }
                                return (
                                    <div className="modal-content-item modal-content-align-start"
                                         key={"detail-modal-" + index}>
                                        <div className="modal-content-divider-2">
                                            <p className="modal-content-text">{label}</p>
                                        </div>
                                        <div className="modal-content-divider-2">
                                            <p className="modal-content-text">
                                                {data[UserListInfo.detailDataName[index]] + UserListInfo.detailDataFormating[index] +
                                                    (label === "이름" ? " (" + Gender.shortText[data[UserListInfo.detailDataName[index + 1]]] + ")" : "")}
                                            </p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        {resetPasswordIsOpen ? <UserPasswordResetModal userid={props.data.userid}
                                                                       onCloseClick={() => setResetPasswordIsOpen(false)}></UserPasswordResetModal> : null}
                        {editRegisterDueIsOpen ?
                            <EditRegisterDueModal data={props.data} onSubmitRegisterDue={onSubmitRegisterDue}
                                                  onCloseClick={() => setEditRegisterDueIsOpen(false)}></EditRegisterDueModal> : null}
                    </div>
                    <div className="modal-footer">
                        <div className="modal-footer-button-container">
                            <div className="modal-button" onClick={onClickDeleteUserAccount}>
                                <p>탈퇴 처리하기</p>
                            </div>
                            <div className="modal-button" onClick={() => setResetPasswordIsOpen(true)}>
                                <p>비밀번호 변경</p>
                            </div>
                            <div className="modal-button" onClick={props.onEditClick}>
                                <p>수강생 정보 수정</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserDetailsModal;